module.exports = (__parcel__import__("eWx6B")).then(() => parcelRequire('jppWD'));